export default __webpack_public_path__ + "static/media/billing.f4523dd9.png";